import { createApi } from '@adv-frontend/modules-query';
import { createBaseQuery } from '@adv-frontend/modules-query';
import {
    getGetOrderRecommendationsUrl,
    GetOrderRecommendationsMethod,
    type GetOrderRecommendationsPathParameters,
    type GetOrderRecommendationsResponseSuccess,
    type GetOrderRecommendationsSearchParams,
} from '@/shared/api/openApi';
import { request } from '@/shared/api/request';

type GetOrderRecommendationsRequestParams = GetOrderRecommendationsSearchParams & GetOrderRecommendationsPathParameters;

const recommendationsApi = createApi({
    name: 'entities/order/api/recommendationsApi',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            GetOrderRecommendations: builder.query<
                GetOrderRecommendationsResponseSuccess,
                GetOrderRecommendationsRequestParams
            >({
                query: (payload) => {
                    return {
                        params: {
                            signature: payload.signature,
                        },
                        url: getGetOrderRecommendationsUrl({
                            order_id: payload.order_id,
                            store_slug: payload.store_slug,
                        }),
                        method: GetOrderRecommendationsMethod,
                    };
                },
            }),
        };
    },
});

export const { useGetOrderRecommendationsQuery } = recommendationsApi;
